import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "../common.module.scss";
import { File } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import CustomUploadFileMultiple from "../../custom-upload/CustomUploadFileMultiple"

const UploadFile = ({ item, onUpdateData, fetchOrderData }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const [isLoading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const uploadFile = (orderId, file, type = 5) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("orderId", orderId);
    formData.append("FileName", file.name);
    formData.append("name", file.name);
    formData.append("Name", file.name);

    return File.addOrderDoc(formData);
  };

  const handleSubmitFiles = async () => {
    if (!files.length) {
      toast.warning(t("orderInfo.orderDecisionAviation.noFilesToSend"));
      return;
    }

    try {
      setLoading(true);
      const orderId = item?.id;

      if (!orderId) {
        toast.error(t("orderInfo.orderDecisionAviation.orderIdNotFound"));
        setLoading(false);
        return;
      }
      const uploadPromises = files.map((file) => uploadFile(orderId, file, 5));

      await Promise.all(uploadPromises);

      toast.success(t("orderInfo.orderDecisionAviation.uploadFilesSuccess"));
      setFiles([]);

      if (fetchOrderData) {
        fetchOrderData();
      }
    } catch (error) {
      console.error(error);
      toast.error(t("orderInfo.genericError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={cn(style.cargo_wrapper)}>
      <div className={cn(style.cargo_title, style.orders_title)}>
        {t("orderInfo.uploadFile.additionalDocsTitle")}
      </div>
      {files.length ? (
        <div style={{ display: "flex", gap: "16px", width: "100%" }}>
          <CustomButton
            text={t("orderInfo.orderDecisionAviation.sendButton")}
            style={{ flex: "1" }}
            onClick={handleSubmitFiles}
            isLoading={isLoading}
          />
        </div>
      ) : null}

      <CustomUploadFileMultiple
        user={user}
        files={files}
        onUploadFiles={(files) => {
          setFiles(files);
        }}
        title={t("orderInfo.uploadFile.uploadAdditionalDocsTitle")}
        buttonText={t("orderInfo.orderDecisionAviation.dragDocsTitlePart1")}
        dragText={t("orderInfo.orderDecisionAviation.dragDocsTitlePart2")}
      />
    </div>
  );
};

export default UploadFile;
